import moment from "moment";
import { useEffect, useState, useMemo } from "react";

interface CardContentData {
    buttonName: string;
    text: string;
    status: string;
}

const getNumber = (value: number) => {
  return (Number.isNaN(value) || value < 0) ? 0 : value;
};

const calculateTimeLeft = (difference: number) => {
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = getNumber(Math.floor((difference / 1000 / 60) % 60));
  const seconds = getNumber(Math.floor((difference / 1000) % 60));

  return [days, hours, minutes, seconds];
};


const useCountdown = (targetDate: string) => {
  const countDownDate = +new Date(targetDate);

  const [countDown, setCountDown] = useState(
    countDownDate - +new Date(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - +new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return useMemo(() => calculateTimeLeft(countDown), [countDown]);
};


export const getCardContent = (saleStatus: string, isSoldOut: boolean, isReserved: boolean, startDate: string, isDetailPage?: boolean): CardContentData => {
  const [days, hours, minutes, seconds] = useCountdown(startDate);
  if (saleStatus === 'pre') {
    if (isDetailPage) {
      return {
        buttonName: 'View Details',
        text:`Sale starts in ${days ? days + ' days' : ''} ${hours} hrs ${minutes} mins ${seconds} secs`,
        status: 'preSale',
      }
    } else {
      return {
          buttonName: 'View Details',
          text: `Starts ${moment(startDate).format('MMMM DD, hh:mm A')}`,
          status: 'preSale',
      };
    }
  } else if (saleStatus === 'during' && isReserved) {
    return {
        buttonName: 'Inquire',
        text: `Inquire`,
        status: 'reserved',
    };
  } else if (saleStatus === 'post' || isSoldOut) {
    return {
        buttonName: isDetailPage ? 'Buy Now' : 'View Details',
        text: `Sold`,
        status: 'sold',
    };
  } else if (saleStatus === 'during') {
    return {
        buttonName: 'Buy Now',
        text: `Available`,
        status: 'duringSale',
    };
  } else {
    return {
        buttonName: 'View Details',
        text: `Available`,
        status: 'noStatus',
    };
  }
};
